<template>
  <section>
    <v-client-table
      :data="echeanciers"
      :columns="columns"
      :options="options">
      <template slot="dateDebut" slot-scope="{ row }">
        {{ func.formatDate(row.dateDebut) }}
      </template>
      <template slot="dateFin" slot-scope="{ row }">
        {{ func.formatDate(row.dateFin) }}
      </template>
      <template slot="montant" slot-scope="{ row }" >
        <div class="is-pulled-right">
          {{ func.formatDevise(row.montant) }}
        </div>
      </template>
      <template slot="montantIndexe" slot-scope="{ row }">
        <div class="is-pulled-right">
          {{ func.formatDevise(
            row.facturationFaite ? row.montant : calculMontantIndexe(row.montant)
          ) }}
        </div>
      </template>
      <template slot="infos" slot-scope="{ row }">
        <b-tooltip
          v-if="row.facturationFaite"
          :label="$t('detailCommande.indexation.popUpEcheancier.echeancierNonIndexable')"
          class="width-100percent"
          position="is-left"
          type="is-warning"
          multiline>
          <b-icon
            icon="alert"
            custom-size="mdi-24px"
            type="is-warning">
          </b-icon>
        </b-tooltip>
      </template>
    </v-client-table>
  </section>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_POP_UP,
  SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import { formatDevise } from '@/services/general/filters/formatDevise';
import formatDate from '@/services/general/formatDate';

export default {
  name: 'IndexationCommandeEcheanc',
  props: {
    commande: {
      type: Object,
      required: true,
    },
    payload: {
      type: Object,
      required: true,
    },
    echeanciers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      func: {
        formatDevise,
        formatDate,
      },
    };
  },
  computed: {
    columns() {
      return [
        'produit',
        'payeur',
        'dateDebut',
        'dateFin',
        'montant',
        'montantIndexe',
        'infos',
      ];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          dateFin: this.$t('detailCommande.indexation.popUpEcheancier.dateFin'),
          dateDebut: this.$t('detailCommande.indexation.popUpEcheancier.dateDebut'),
          payeur: this.$t('detailCommande.indexation.popUpEcheancier.payeur'),
          montant: this.$t('detailCommande.indexation.popUpEcheancier.montant'),
          produit: this.$t('detailCommande.indexation.popUpEcheancier.produit'),
          montantIndexe: this.$t('detailCommande.indexation.popUpEcheancier.montantIndexe'),
          infos: '',
        },
        sortable: [],
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_POP_UP,
      };
    },
  },
  methods: {
    calculMontantIndexe(montant) {
      return montant + (montant * (this.payload.pourcentageReel / 100));
    },
  },
};
</script>
